// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__33R6D","title":"ClientInsurance_title__S1Moa","itemText":"ClientInsurance_itemText__1GDaz"};